// Single source of truth for the Privacy Policy, Terms and Conditions, and
// Permissions Notice. The dates render at the top of all three pages, so they
// only stay in sync if every surface reads them from here.
//
// LEGAL_EFFECTIVE_DATE: when the current version takes effect. Bump it only for
// a material change, and give users notice before it applies.
// LEGAL_LAST_UPDATED: when the text was last edited, material or not.
export const LEGAL_EFFECTIVE_DATE = "August 19, 2026";
export const LEGAL_LAST_UPDATED = "August 19, 2026";

export type LegalPage = {
  href: string;
  label: string;
  title: string;
  description: string;
};

export const LEGAL_PAGES: LegalPage[] = [
  {
    href: "/privacy-policy",
    label: "Privacy Policy",
    title: "Privacy Policy | Youdle",
    description:
      "How Youdle collects, uses, shares, and deletes your information, including accounts, searches, community posts, location, AI features, cookies, and your privacy choices.",
  },
  {
    href: "/terms",
    label: "Terms and Conditions",
    title: "Terms and Conditions | Youdle",
    description:
      "The rules for using Youdle, including accounts, product and availability information, AI-assisted features, community content, and our Acceptable Use Policy.",
  },
  {
    href: "/permissions",
    label: "Permissions Notice",
    title: "Permissions Notice | Youdle",
    description:
      "Every browser and device permission Youdle asks for — location, camera and photos, alerts, cookies, and social sign-in — what each is used for, and how to turn it off.",
  },
];

export const getLegalPage = (href: string): LegalPage | undefined =>
  LEGAL_PAGES.find((page) => page.href === href);
